export const filters = {};

export function registerFilters(Vue, registerLog) {
  for (var name in filters) {
    if (registerLog) {
      console.time('register filter ' + name);
      Vue.component(name, filters[name]);
      console.timeEnd('register filter ' + name);
    } else {
      Vue.component(name, filters[name]);
    }

  }
}

export default filters;